var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM10.8332 15.8337H9.1665V14.167H10.8332V15.8337ZM12.5582 9.37533L11.8082 10.142C11.2082 10.7503 10.8332 11.2503 10.8332 12.5003H9.1665V12.0837C9.1665 11.167 9.5415 10.3337 10.1415 9.72533L11.1748 8.67533C11.4832 8.37533 11.6665 7.95866 11.6665 7.50033C11.6665 6.58366 10.9165 5.83366 9.99984 5.83366C9.08317 5.83366 8.33317 6.58366 8.33317 7.50033H6.6665C6.6665 5.65866 8.15817 4.16699 9.99984 4.16699C11.8415 4.16699 13.3332 5.65866 13.3332 7.50033C13.3332 8.23366 13.0332 8.90033 12.5582 9.37533Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHelp);
export default __webpack_public_path__ + "static/media/nav-help.ab0337ab4914e3257c28fc3f1aff2420.svg";
export { ForwardRef as ReactComponent };